import React from 'react';
import Input from '../componenti/input/Simple';
import InputProv from '../componenti/input/Provincia';

const Certificazione = ({
    anteprima, 
    inputValues,
    handleOnChange,
    }) => {
    return (
        <>
            <div style={{padding:'20px'}}>DICHIARA</div>
            di avere conseguito il seguente titolo di studio:
            <Input
                anteprima={anteprima} 
                inputValues={inputValues}
                handleOnChange={handleOnChange}
                inputName='titoloStudio'
            />
            nell’anno scolastico
            <Input
                anteprima={anteprima} 
                inputValues={inputValues}
                handleOnChange={handleOnChange}
                inputName='annoScolastico'
            />
            presso
            <Input
                anteprima={anteprima} 
                inputValues={inputValues}
                handleOnChange={handleOnChange}
                inputName='scuola'
            />
            con sede a
            <Input
                anteprima={anteprima} 
                inputValues={inputValues}
                handleOnChange={handleOnChange}
                inputName='scuolaCit'
            />
            <InputProv
                anteprima={anteprima} 
                inputValues={inputValues}
                handleOnChange={handleOnChange}
                inputName='provScuolaCit'
            />
            e di aver riportato la seguente votazione
            <Input
                anteprima={anteprima} 
                inputValues={inputValues}
                handleOnChange={handleOnChange}
                inputName='votazione'
            />
            <span>/</span>
            <Input
                anteprima={anteprima} 
                inputValues={inputValues}
                handleOnChange={handleOnChange}
                inputName='votazione1'
            />
            .
            Dichiara inoltre che la durata legale del corso è di anni
            <Input
                anteprima={anteprima} 
                inputValues={inputValues}
                handleOnChange={handleOnChange}
                inputName='durataAnni'
            />
        </>
        );
    }

export default Certificazione;